module.exports = __webpack_public_path__ + "media/images/logos/hi_bob-ed67ebe66862641eea27a45fa3eb3a8e.png";